// removed by extract-text-webpack-plugin
module.exports = {"picker":"w18WHI1a9EZEpKytqT5Eo","pick":"_1zODw5b8amqiyhFRO0Q2p"};


//////////////////
// WEBPACK FOOTER
// ./app/components/OrderPicker/style.scss
// module id = 1045
// module chunks = 0